import Vue from 'vue'
import App from '@/App.vue'
import '@/registerServiceWorker'
import router from '@/plugins/router'
import vuetify from '@/plugins/vuetify'
import store from '@/plugins/store'
import '@/plugins/realtime'
import '@/plugins/ga'
import '@/plugins/tenant'
import i18n from '@/plugins/i18n'
import {MUTATION_INCREMENT, MUTATION_INIT} from '@/plugins/store'
import {} from '@/plugins/http'
import {} from '@/plugins/api'
import {} from '@/plugins/common'
import appDataset from '@/plugins/appDataset'
import '@/plugins/datefns'
import eventBus, {EVENT_NAVIGATE_TO} from '@/plugins/eventbus'
import VueClipboard from 'vue-clipboard2'
import UserWidget from "@/widgets/UserWidget";
import MultiIcon from "@/widgets/MultiIcon";
import GameOverview from '@/components/GameOverview';
import DatetimePicker from 'vuetify-datetime-picker'
import vueDebounce from 'vue-debounce'
import {} from '@/plugins/cmp'

Vue.use(vueDebounce)
Vue.use(VueClipboard)
Vue.use(DatetimePicker)

Vue.config.productionTip = false

Vue.component("user-widget", UserWidget)
Vue.component("multi-icon", MultiIcon)
Vue.component("game-overview", GameOverview)

store.commit(MUTATION_INIT)

new Vue({
  i18n,
  router,
  vuetify,
  store,
  render: h => h(App, {props: {... appDataset}}),
}).$mount('#app')

store.commit(MUTATION_INCREMENT)
// console.log(`count=${store.state.count}`)

eventBus.$on(EVENT_NAVIGATE_TO, (to) => {
  router.push(to)
});

if (store.state.isLoggedIn) {
  if (router.currentRoute.path == '/') {
    router.push('/dashboard')
  }
}

import '@/plugins/nativeApp'
